(function () {
  'use strict';

  $(function () {
    // Init Foundation
    $(document).foundation();

    // Slick Slider
    function slickInit() {
      if ($('.slick-slider').length) {
        $('.slick-slider:not(#ee-cutaway--slick-slider)')
          .not('.slick-initialized')
          .each(function () {
            $(this).on('init', function (event, slick) {
              if (!slick.$slider.hasClass('has-dots')) {
                slick.$slider.find('.slick-dots').attr('aria-hidden', true);
                slick.$slider
                  .find('.slick-dots li, .slick-dots button')
                  .attr('tabindex', -1);
              }
            });
            if ($(this).parents('.dark-text').length) {
              $(this).slick({
                dots: true,
                adaptiveHeight: true,
                lazyLoad: 'progressive',
                prevArrow: '<button class="orbit-previous"><span class="show-for-sr">Previous Slide</span><img src="/etc/icons/icon-left-dark.png" alt="Previous Slide"></button>',
                nextArrow: '<button class="orbit-next"><span class="show-for-sr">Next Slide</span><img src="/etc/icons/icon-right-dark.png" alt="Previous Slide"></button>',
              });
            } else {
              $(this).slick({
                dots: true,
                adaptiveHeight: true,
                lazyLoad: 'progressive',
                prevArrow: '<button class="orbit-previous"><span class="show-for-sr">Previous Slide</span><img src="/etc/icons/icon-left.png" alt="Previous Slide"></button>',
                nextArrow: '<button class="orbit-next"><span class="show-for-sr">Next Slide</span><img src="/etc/icons/icon-right.png" alt="Previous Slide"></button>',
              });
            }
            var label = $(this).attr('aria-label');
            $(this)
              .find('.slick-track')
              .attr('aria-label', label);
            $(this)
              .attr('aria-label', '')
              .removeAttr('aria-label');
            $(this)
              .find('.slick-slide, .slick-dots li')
              .removeAttr('role');
          });
      }
    }

    // Lazy loading communities and floor plans
    function load(img) {
      img.fadeOut(0, function () {
        img.fadeIn(1000);
      });
      slickInit();
    }

    $('.lazy').lazyload({
      trigger: 'appear',
      load: load,
      threshold: 500,
    });

    // Fix button/callout height on carousel hero
    if ($('.carousel-hero .orbit').length > 0 && $(window).width() >= 1024) {
      setTimeout(function () {
        $('.carousel-hero .orbit').each(function () {
          orbCallouts(this);
        });
      }, 250);

      $('.carousel-hero .orbit').on('slidechange.zf.orbit', function () {
        var orb = $(this);
        setTimeout(function () {
          orbCallouts(orb);
        }, 20);
      });
    }

    $("a[role='tab']").click(function () {
      $(window).trigger('resize');
    });


    if ($(window).width() >= 1024) {
      heroHeight();

      var searchOverlay = $('#site-search--overlay');
      $('body').on(
        'click',
        'li.search, #button--search, #button--search--small',
        function (e) {
          e.preventDefault();

          if (searchOverlay.hasClass('hidden')) {
            searchOverlay.removeClass('hidden');
          }
          if (!$('body').hasClass('no-scroll')) {
            $('body').addClass('no-scroll');
            }
            $('#site-search--input').focus();
        }
      );
      $('body').on('click', '#site-search--close a', function (e) {
        e.preventDefault();

        if (!searchOverlay.hasClass('hidden')) {
          searchOverlay.addClass('hidden');
        }
        if ($('body').hasClass('no-scroll')) {
          $('body').removeClass('no-scroll');
        }
      });
    } else {
      $(".hero:not('.hero--background-video')")
        .has('.full-height')
        .css('height', 'auto')
        .find('.full-height')
        .css('height', 'auto');
    }

    videoHero();
    videoFullWidth();
    slickInit();
  });

  $(window).resize(function () {
    _.debounce(function () {
      if ($(window).width() < 1024) {
        $('#menu-toggle .hamburger').removeClass('is-active');
        $('#main-nav').removeClass('is-dropdown');
      }
    }, 250);

    if ($(window).width() >= 1024) {
      heroHeight();
      if ($('.carousel-hero .orbit').length > 0) {
        $('.carousel-hero .orbit').each(function () {
          orbCallouts(this);
        });
      }
    } else {
      $('.hero')
        .has('.full-height')
        .css('height', 'auto')
        .find('.full-height')
        .css('height', 'auto');
    }

    videoHero();
    videoFullWidth();
  });

  if ($('.compare').length) {
    $('.compare').on(
      'scroll',
      _.throttle(function (e) {
        var documentScrollLeft = e.currentTarget.scrollLeft;
        var lastScrollLeft = 0;
        if (lastScrollLeft !== documentScrollLeft) {
          lastScrollLeft = documentScrollLeft;
          closeTooltips();
        }
      }, 100)
    );
  }

  $(window).on('changed.zf.mediaquery', function (event, newSize) {
    if (newSize === 'small' || newSize === 'medium') {
      var elem = new Foundation.Drilldown($('#main-nav'));
    } else {
      if ($('#main-nav[data-drilldown]').length) {
        $('#main-nav[data-drilldown]').foundation('destroy');
      }
    }
    if (newSize === 'medium' || newSize === 'large') {
      $('.tabs-title.is-active > a').each(function () {
        var href = $(this).attr('href');
        $(href + ':not(.is-active)').addClass('is-active');
      });
    }
  });

  // don't use tab functionality on links with .external
  $('.tabs-title.external a').on('click touchstart', function () {
    window.location.href = $(this).attr('href');
    return false;
  });

  // Nav drilldown
  $('#main-nav').on('open.zf.drilldown', function () {
    $('#main-nav').addClass('no-scroll');
  });
  $('#main-nav').on('hide.zf.drilldown', function () {
    $('#main-nav').removeClass('no-scroll');
  });
  $('#main-nav').on('closed.zf.drilldown', function () {
    $('#main-nav').removeClass('no-scroll');
  });

  // Scroll to href on click
  $('body').on('click touchstart', 'a.scroll-to-anchor', function (e) {
    e.preventDefault();

    var dest = $(this).attr('href');

    if (dest === '#') {
      dest = 'body';
    }

    $('html,body').animate({
      scrollTop: $(dest).offset().top - $('.nav--main').outerHeight(),
    },
      'slow'
    );
  });

  /* jQuery Extensions */
  $.fn.swapClass = function (class1, class2) {
    if (!class1 || !class2) {
      return this;
    }

    return this.each(function () {
      var $el = $(this);
      if ($el.hasClass(class1) || $el.hasClass(class2)) {
        $el.toggleClass(class1 + ' ' + class2);
      } else {
        $el.addClass(class1);
      }
    });
  };

  function heroHeight() {
    // if($('.hero:not(".hero--background-video") .full-height').length > 0) {
    // $('.hero').css('height', $(window).height()).find('.full-height').css('height', $(window).height());
    // }

    // Set the full-height hero height
    $(".hero:not('.hero--background-video')")
      .has('.full-height')
      .css('height', $(window).height())
      .find('.full-height')
      .css('height', $(window).height());

    if ($('.hero--background-video .full-height').length > 0) {
      $('.hero--background-video .full-height')
        .parent()
        .css('height', $(window).height());
    }
  }

  function orbCallouts(orb) {
    var figcaption = $(orb).find('.orbit-slide.is-active .orbit-caption');
    $(orb)
      .find('.callout')
      .height(figcaption.outerHeight());
  }

  function closeTooltips() {
    if ($('.tooltip').length) {
      $('.has-tip').each(function () {
        $(this).foundation('hide');
      });
    }
  }

  function videoHero() {
    var ismobile = /iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test(
      navigator.userAgent.toLowerCase()
    );
    if (!ismobile || $(window).width() > 1024) {
      $('.hero--background-video').each(function () {
        var hero = $(this);
        var vID = hero.data('video-id');

        if (!hero.find('.hero--video-container.loaded').length) {
          if (!hero.find('.hero--video-container').attr('data-html5-video')) {
            hero.find('.hero--video-container').YTPlayer({
              fitToBackground: false,
              videoId: vID,
              controls: 0,
              loop: 1,
              modestbranding: 1,
              rel: 0,
              showinfo: 0,
              callback: function () {
                $(
                  '.video-container, .video-container iframe, .video-container .ytp-watermark.yt-uix-sessionlink'
                ).attr('tabindex', '-1');
              },
            });
          }
        }
      });
    }
  }

  function videoFullWidth() {
    var ismobile = /iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test(
      navigator.userAgent.toLowerCase()
    );
    if (!ismobile || $(window).width() > 1024) {
      // loop through and initialize fullscreen background video
      $('.full-width-video').each(function () {
        var div = $(this);
        var vID = div.data('video-id');

        if (!div.find('.video-container.loaded').length) {
          div.find('.video-container').YTPlayer({
            fitToBackground: false,
            videoId: vID,
            controls: 0,
            loop: 1,
            modestbranding: 1,
            rel: 0,
            showinfo: 0,
            callback: function () {
              $(
                '.video-container, .video-container iframe, .video-container .ytp-watermark.yt-uix-sessionlink'
              ).attr('tabindex', '-1');
            },
          });
        }
      });
    }
  }

  // http://stackoverflow.com/questions/17534661/make-anchor-link-go-some-pixels-above-where-its-linked-to
  // This checks for an anchor link and offsets for the nav height
  function offsetAnchor() {
    if (location.hash.length !== 0) {
      var nav = $('.nav--main');
      var topPromo = $('.promotion-top');
      var navPad = 36;
      if (topPromo.length > 0) {
        window.scrollTo(window.scrollX, window.scrollY - nav.outerHeight() - topPromo.outerHeight() + navPad);
      } else {
        window.scrollTo(window.scrollX, window.scrollY - nav.outerHeight() + navPad);
      }
    }
  }

  function moveAnchor() {
    var anchors = $('a[id^="anchor_"]').not('a[name="Disclaimer"]');
    var parent = $('[aria-label]');
    anchors.each(function (i, val) {
      var closest = $(this).closest(parent);
      var text = $(this).text();
      $(this).replaceWith(text).detach().insertBefore(closest);
      $(this).text('');
    });
  }
  moveAnchor();

  // * Resource Center
  $(function () {
    if ($('.resource-center').length) {
      $('.resource-center').each(function () {
        var self = $(this);
        if (self.find('.resource-center-item').length >= 10) {
          self.find('.resource-center-item:nth-child(n+10)').fadeOut(1);
          self.find('.load-more').removeClass('hidden');
          self.find('.load-more a').on('click vclick', function () {
            self.find('.resource-center-item:nth-child(n+10)').each(function () {
              var e = $(this);
              if (!e.is(':visible')) {
                e.fadeIn(500);
                self.find('.load-more a').hide();
              } else {
                e.fadeOut(500);
                self.find('.load-more a').show();
                var distance = self.find('.resource-center-heading').offset()
                  .top;
                var offset = $('.nav--main').height();
                $('html, body')
                  .stop()
                  .animate({
                    scrollTop: distance - offset,
                  },
                    1000
                  );
              }
            });
          });
        }
      });
    }
  });

  // * LiveChat Support
  //var LiveAgent = LiveAgent || {};

  //LiveAgent = {
  //  animationDuration: 750,
  //  setTimer: function (milliseconds) {
  //    var isMobile =
  //      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
  //        navigator.userAgent
  //      ) ||
  //      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
  //        navigator.userAgent.substr(0, 4)
  //      );
  //    setTimeout(function () {
  //      if (!isMobile) {
  //        LiveAgent.show();
  //      }
  //    }, milliseconds);
  //  },
  //  show: function () {
  //    LiveAgent.generateImagePaths(LiveAgent.basePath);
  //    $('#liveagent_button_online_5731A000000PElV img')
  //      .removeAttr('src')
  //      .attr('src', LiveAgent.replaceImage);
  //    $('#js-live-agent-button-container').animate({
  //      bottom: 30,
  //    },
  //      LiveAgent.animationDuration
  //    );
  //  },
  //  randomGender: function (img, path) {
  //    if (typeof path === 'undefined') {
  //      path = '';
  //    }
  //    var gender = 'f';
  //    if (Math.floor(Math.random() * 2) + 0) {
  //      gender = 'm';
  //    }
  //    return path + gender + '-' + img;
  //  },
  //  generateImagePaths: function (base) {
  //    LiveAgent.replaceImage = LiveAgent.randomGender(
  //      LiveAgent.baseImage,
  //      base
  //    );
  //  },
  //  hideLiveChat: function () {
  //    var url = window.location.href;
  //    if (url.endsWith('/contact') || url.endsWith('/homes')) {
  //      $('#js-live-agent-button-container').css({
  //        display: 'none',
  //      });
  //    }
  //  },
  //  baseImage: 'home-online.png',
  //  basePath: window.location.protocol +
  //    '//' +
  //    window.location.host +
  //    '/etc/images/live-agent/',
  //  replaceImage: '',
  //};

  // * Interest List Form
  $(function () {
    $('body').on('submit', '.interest-list form', function () {
      $(this)
        .find('input[type="submit"]')
        .prop('disabled', true);

      $(this)
        .parent()
        .parent()
        .slideUp();
      $(this)
        .parent()
        .parent()
        .parent()
        .find('.interest-list--response')
        .slideDown();

      return false;
    });
  });

  $(document).ready(function () {
    $('.js-close-popup').on('click vclick', function () {
      //$(this)
      //  .parents('#js-live-agent-button-container')
      //  .hide();
    });
    //LiveAgent.hideLiveChat();
  });

  // This will capture hash changes while on the page
  window.addEventListener('hashchange', offsetAnchor);
  // This is here so that when you enter the page with a hash,
  // it can provide the offset in that case too. Having a timeout
  // seems necessary to allow the browser to jump to the anchor first.
  window.setTimeout(offsetAnchor, 1);

  // Scroll to top of current Accordion item on change active accordion item
  $(document).ready(function () {
    $('.accordion').on('down.zf.accordion', function (event) {
      var accordion = event.target;
      var urlHash = window.location.hash.replace('#', '');
      var navHeight = $('.nav--bottom').height() + $('.nav--top').height();
      var winWidth = $(window).width();
      if (urlHash && winWidth < 1024) {
        $('html, body').animate({
          scrollTop: $(accordion)
            .find('.is-active')
            .offset().top - navHeight,
        },
          250
        );
      }
    });

    $('.accordion-title').on('click vclick keyup', function (event) {
      if (
        $(event.target)
          .closest('.accordion-item')
          .hasClass('is-active')
      ) {
        var accordion = $(event.target).closest('.accordion');
        var active = $(accordion).find('.accordion-item.is-active');
        accordion = event.target;
        var hash = !active.attr('id') ?
          active
            .find('.accordion-title')
            .attr('href')
            .replace('#', '') :
          active.attr('id');
        history.replaceState(undefined, undefined, '#' + hash);
      } else {
        history.replaceState(undefined, undefined, ' ');
      }
    });

    if ($('.drawer .accordion').length) {
      var hash = window.location.hash.replace('#', '');

      if (hash) {
        var hashEl = $('#' + hash);
        if (!hashEl.parent().hasClass('is-active')) {
          setTimeout(function () {
            hashEl.closest('.accordion').foundation('down', $('#' + hash));
          }, 1000);
        }
      }
    }
  });

  $(function () {
    // * Footer Modal Triggers
    $('#footer-optin').on('submit', function (e) {
      e.preventDefault();
      handleInput();
    });
    $('#footer-open-modal-trigger').on('click touchstart keypress', function () {
      handleInput();
    });
    var handleInput = function () {
      $('#footer-optin').foundation('validateForm');
      if (!$('#footer-open-modal-email').hasClass('is-invalid-input')) {
        $('#footer-open-modal').data(
          'email',
          $('#footer-open-modal-email').val()
        );
        $('#footer-open-modal').click();
      }
    };

    // * Footer Modal Triggers
    $('.email-optin').on('submit', function (e) {
      e.preventDefault();
      handleOptinInput(this);
    });
    $('.open-modal-trigger').on('click touchstart keypress', function (e) {
      e.preventDefault();
      handleOptinInput(this);
    });
    var handleOptinInput = function (e) {
      var form = $(e).closest('form');
      form.foundation('validateForm');
      if (form.find('.is-invalid-input').length === 0) {
        var trigger = form.find('.open-modal');
        var address = form
          .find('input')
          .first()
          .val();

        trigger.data('email', address);
        trigger.click();
      }
    };

    // * Handle Opening Pre-Select on Modals
    $("[data-open='contact-form-modal']").on(
      'click touchstart keypress',
      function () {
        var trigger = $(this);
        var email = trigger.data('email');
        var metro = trigger.data('metro');
        var community = trigger.data('community');
        var mode = trigger.data('mode');

        $('body').addClass('no-scroll');

        if (email) {
          $('#modal_email').val(email);
        }

        if (mode === 'footer') {
          $('#modal_newsletter_optin').prop('checked', true);
          $('#contact-form-modal .question').hide();
        }

        if (metro && community) {
          if ($('#metro-area-select' + ' option[value=' + metro + ']').length) {
            $('#metro-area-select')
              .val(metro)
              .prop('selected', true)
              .change();
            $(document).ajaxStop(function () {
              if (
                $('#community-select' + ' option[value=' + community + ']')
                  .length
              ) {
                $('#community-select')
                  .val(community)
                  .prop('selected', true)
                  .change();
              }
            });
          }
        }
      }
    );
    $('#contact-form-modal').on('closed.zf.reveal', function () {
      $('body').removeClass('no-scroll');
    });

    // Warranty Modal
    $("[data-open='warranty-form-modal']").on(
      'click touchstart keypress',
      function () {
        var trigger = $(this);
        var mode = trigger.data('mode');

        $('body').addClass('no-scroll');
        if (mode === 'submit') {
          $('#warranty-form-modal-close').hide();
          $('#warranty-form-modal-cancel').hide();
          $('#warranty-form-modal-submit').show();
        } else {
          $('#warranty-form-modal-close').show();
          $('#warranty-form-modal-cancel').show();
          $('#warranty-form-modal-submit').hide();
        }
      }
    );
    $('#warranty-form-modal').on('closed.zf.reveal', function () {
      $('body').removeClass('no-scroll');
    });
  });

  // Compare module multiple item equalizer using data-equal="X,Y,Z"
  $(function Equal() {
    var compareHeight = function () {
      $('[data-equal-watch]').height('auto');
      setTimeout(function () {
        $('[data-equal]').each(function () {
          var parent = $(this);
          var type = parent.attr('data-equal');
          var array = type.split(',');
          var H = 0;
          $.each(array, function (i, e) {
            parent.find('[data-equal-watch=' + e + ']').each(function () {
              var h = $(this).innerHeight();
              if (h > H) {
                H = h;
              }
            });
            $('[data-equal-watch=' + e + ']').innerHeight(H);
          });
        });
      }, 100);
    };

    if ($('[data-equal]').length > 0) {
      compareHeight();
    }

    $(window).resize(compareHeight);
  });

  // * Pause videos in tabs on tab change
  $(document).on('change.zf.tabs', '[data-tabs]', function () {
    var videos = $('.tabs-content iframe:hidden');
    videos.each(function () {
      var src = $(this).attr('src');
      $(this).attr('src', '');
      $(this).attr('src', src);
    });

    if ($('#tab-navigator')) {
      if (!$('#tab-navigator').is(':visible')) {
        var currentTab = $('.explore-floorplan')
          .find('.tabs-panel.is-active')
          .first()
          .prop('id');
        var dropdownTab = $(
          '#tab-navigator option[value="' + currentTab + '"]'
        );
        $('#tab-navigator')
          .val('#' + currentTab)
          .change();
      }
    }

    if ($('.slick-slider')) {
      $('.slick-slider').slick('setPosition', 0);
    }
  });

  $(function () {
    var heightEqualizer = function () {
      $('[data-equalize-height] .site-search--content-block').height('auto');
      var tallestContentBlockHeight = 0,
        lastHeight = 0;
      $('[data-equalize-height] .site-search--content-block').each(function () {
        var h = $(this).height();
        if (h > lastHeight) {
          tallestContentBlockHeight = h;
        }
        lastHeight = h;
      });
      $('[data-equalize-height] .site-search--content-block').height(
        tallestContentBlockHeight
      );
    };

    if ($('.search-options').length > 0 && $(window).width() >= 640) {
      heightEqualizer();
    }

    $(window).resize(heightEqualizer);
  });

  // * Prevent some froms from submitting
  $('.no-submit').on('submit', function (e) {
    e.preventDefault();
    return false;
  });

  function showMetroImages(el) {
    var windowHeight = $(window).height();
    $(el).each(function () {
      var thisPos = $(this).offset().top;
      var topOfWindow = $(window).scrollTop();
      if (topOfWindow + windowHeight - 200 > thisPos) {
        $(this).addClass('fade-in');
      }
    });
  }

  $(window).scroll(function () {
    showMetroImages('.community-horizontal .image img');
  });

  $(function () {
    // COLLECTIONS MODAL GALLERY
    // force slick slider to display images when inside a modal
    $('[data-reveal]').on('open.zf.reveal', function () {
      $('[data-reveal] .slick-slider').slick('setPosition');
      $(window).trigger('resize');
    });

    // BACK TO TOP/FILTERS
    var scrollTopWidget = $('#backtofilters');
    if (scrollTopWidget.length > 0) {
      $(window).on('scroll', function () {
        var hT = $('#search-header, #customer-web-display').offset().top,
          hH = $('#search-header, #customer-web-display').outerHeight(),
          wH = $(window).height(),
          wS = $(this).scrollTop();
        if (wS > hT + hH - wH) {
          scrollTopWidget.addClass('scrolling');
        }
        if (wS < hT - hH + wH) {
          scrollTopWidget.removeClass('scrolling');
        }
      });
    }

    scrollTopWidget.on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $('#search-header, #customer-web-display').offset().top - 50,
      },
        800
      );
    });

    // FORCE SCROLL TO ANCHOR
    $(window).load(function () {
      var hash = location.hash.replace('#', '');
      // generic hash
      var target = $('[id="' + hash + '"]');
      if (hash != '') {
        $('html, body').animate({
          scrollTop: target.offset().top,
        }, {
            // keep checking because of lazy loading
            duration: 1000,
            step: function (now, fx) {
              offsetAnchor();
            }
          });
      }
    });
  });

  // HIDE LIVECHAT OFFLINE BUTTON WHEN ONLINE
  if (!window._laq) {
    window._laq = [];
  }
  window._laq.push(function () {
    liveagent.showWhenOnline(
      '5731A000000PElV',
      document.getElementById('liveagent_button_online_5731A000000PElV')
    );
    liveagent.showWhenOffline(
      '5731A000000PElV',
      document.getElementById('liveagent_button_offline_5731A000000PElV')
    );
  });

  $(function () {
    // HEADER PROMO PADDING
    function topPromoPadding(el) {
      if ($('.promotion-top').length != 0) {
        el.addClass('banner-present');
        if ($('.carousel-hero').length > 0) {
          $('.carousel-hero').addClass('carousel-banner-nav-padding');
        }
      } else {
        el.removeClass('banner-present');
        if ($('.carousel-hero').length > 0) {
          $('.carousel-hero').addClass('carousel-nav-padding');
        }
      }
    }

    topPromoPadding($('nav.nav--main'));
    topPromoPadding($('.hero'));
    topPromoPadding($('.breadcrumbs-container'));

    // CLOSE ALL ACCORDIONS
    $('#close-accordions').on('click', function (e) {
      e.preventDefault();
      $('.accordion.responsive-tabs').foundation(
        'up',
        $('.accordion.responsive-tabs .accordion-content')
      );
      $('html, body').animate({
        scrollTop: $('.accordion.responsive-tabs').position().top - 80,
      },
        1000
      );
    });
  });

  // Display Company name when agent radio button selected
  var localAgent = $('#contact_homebuyer_checkbox, #contact_agent_checkbox');
  var prefsAgent = $('#homebuyer_checkbox, #agent_checkbox, #contact_modal_homebuyer_checkbox, #contact_modal_agent_checkbox');
  var contactCompany = $('#contact-info-wrap #FormModel_CompanyName');
  var prefsCompany = $('#prefs-info-wrap #FormModel_CompanyName, #contactmodal-info-wrap #FormModel_CompanyName, #contact-info-wrap #FormModel_CompanyName');
  var interestConmpany = $('#interest-info-wrap #FormModel_CompanyName');

  contactCompany.prop('required', false);
  prefsCompany.prop('required', false);
  interestConmpany.prop('required', false);

  localAgent.on('change', function () {
    showCompany(this, $('#contact-info-wrap'), contactCompany);
  });
  prefsAgent.on('change', function () {
    showCompany(this, $('#prefs-info-wrap'), prefsCompany);
    showCompany(this, $('#interest-info-wrap'), interestConmpany);
    showCompany(this, $('#contactmodal-info-wrap'), interestConmpany);
  });

  function showCompany(that, wrap, info) {
    if (that.value.toLowerCase() == 'agent') {
      wrap.removeClass('hide');
      info.prop('required', true);
    }
    if (that.value.toLowerCase() == 'homebuyer') {
      wrap.addClass('hide');
      info.prop('required', false);
    }
  }

  // PROMO BUTTON FIX
  var twoby = $('article.two-by-two');
  twoby.each(function () {
    $(this).find('a').removeClass('button--blue--solid').addClass('button--white--solid');
  });

})();

